import React, { Fragment, useEffect, useState } from 'react'
import TopHeader from '../../../Components/TopHeader/TopHeader'
import { useNavigate } from 'react-router-dom'
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Constant from '../../../Utils/Constant';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NoDataImg from '../../../Components/NoDataFound/NoDataFound';
import { GET_BY_ID_REPORT_USERS_ACTION } from '../../../Redux/Slices/ReportSlice/ReportSlice.action';

const ReportViewDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [reportedDetails, setReportedDetails] = useState([]);

    useEffect(() => {
        if (location?.state?.id) {
            const userId = location?.state?.id;
            getReportedDetails(userId);
        }
    }, [location?.state?.id]);

    const getReportedDetails = async (id) => {
        try {
            setIsLoading(true);
            const result = await dispatch(GET_BY_ID_REPORT_USERS_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setReportedDetails(result?.payload?.r);
            } else {
                setReportedDetails([]);
            }
        } catch (error) {
            console.error("Error fetching user details", error);
        } finally {
            setIsLoading(false);
        }
    };
    const skeletonItems = Array.from({ length: 6 }).map((_, index) => (
        <Grid item xs={12} sm={5} md={5} lg={3} key={index}>
            <Card sx={{ background: "rgba(230, 245, 247, 1)", position: "relative" }}>
                <CardContent>
                    <Skeleton height={116} width={116} borderRadius={50} />
                    <Box sx={{}}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                            Full Name
                        </Typography>
                        <Skeleton height={20} />
                    </Box>
                    <Box sx={{}}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                            Email
                        </Typography>
                        <Skeleton height={20} />
                    </Box>
                    <Box sx={{}}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                            Report Type
                        </Typography>
                        <Skeleton height={20} />
                    </Box>
                    <Box sx={{}}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                            Description
                        </Typography>
                        <Skeleton height={20} />
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    ));
    return (
        <Fragment>
            <TopHeader
                title={"Reported Details"}
                onClick={() => navigate(-1)}
                type="button"
                showButton={false}
            />
            <Box
                sx={{
                    padding: "100px 15px 40px 15px",
                    maxWidth: { xs: "100%" },
                    margin: "0 auto",
                    width: "100%",
                }}
            >
                <Grid container spacing={4}>
                    {isLoading ? skeletonItems : reportedDetails?.length > 0 ? reportedDetails.map((elem, index) => {
                        return (
                            <Grid item xs={12} sm={5} md={5} lg={3} key={index}>
                                <Card sx={{ background: "rgba(230, 245, 247, 1)", position: "relative" }}>
                                    <CardContent>
                                        {elem?.profile_img ? 
                                            <Box sx={{ width: '116px', margin: '0 auto 30px auto' }}>
                                                <img
                                                    src={`${Constant.BASE_URL}${elem?.profile_img}`}
                                                    alt="user_Profile"
                                                    style={{
                                                        width: "116px",
                                                        height: "116px",
                                                        objectFit: "cover",
                                                        borderRadius: "50%",
                                                        objectPosition: "top",
                                                    }}
                                                />
                                            </Box> : 
                                            <AccountCircleIcon sx={{ fontSize: "100px" }} />
                                        }
                                        <Box sx={{}}>
                                            <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                                                Full Name
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "rgba(8, 85, 127, 1)", textAlign: "left", width: "100%", paddingTop: "4px", textTransform: "capitalize", fontFamily: "Outfit" }}>
                                                {elem?.full_name || "Not available"}
                                            </Typography>
                                        </Box>
                                        <Box sx={{}}>
                                            <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                                                Email
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "rgba(8, 85, 127, 1)", textAlign: "left", width: "100%", paddingTop: "4px", textTransform: "capitalize", fontFamily: "Outfit" }}>
                                                {elem?.email || "Not available"}
                                            </Typography>
                                        </Box>
                                        <Box sx={{}}>
                                            <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                                                Report Type
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "rgba(8, 85, 127, 1)", textAlign: "left", width: "100%", paddingTop: "4px", textTransform: "capitalize", fontFamily: "Outfit" }}>
                                                {elem?.report_type || "Not available"}
                                            </Typography>
                                        </Box>
                                        <Box sx={{}}>
                                            <Typography sx={{ fontSize: "16px", fontWeight: "300", color: "rgba(0, 0, 0, 0.7)", textAlign: "left", width: "100%", fontFamily: "Outfit" }}>
                                                Description
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "rgba(8, 85, 127, 1)", textAlign: "left", width: "100%", paddingTop: "4px", textTransform: "capitalize", fontFamily: "Outfit" }}>
                                                {elem?.description || "Not available"}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    }) : <Grid item xs={12}><NoDataImg /> </Grid>}
                </Grid>
            </Box>
        </Fragment>
    );
}

export default ReportViewDetails;
